<template>
  <v-container fluid class="pa-2" style="margin-top: 2%; max-width: 100%">
    <v-dialog v-model="confirmDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('system.alert') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ mensagemDialog }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">
            {{ $t('button.dismiss') }}
          </v-btn>
          <v-btn color="red accent-4" class="white--text" @click="deleteFromDatabase">
            {{ $t('button.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <recursos-operacionais-split-layout
      ref="detalheSplit"
      preview-type="area"
      :preview-item="areaSelecionada"
      :preview-items="selecionadas"
      :parametros-total="selecionadas.length"
      :parametros-page.sync="parametrosPage"
      :parametros-label="parametrosLabel"
      :area-map-data="areaMapData"
      :token="token"
      :can-edit="canEdit"
      :can-insert="canInsert"
      @map-action="onMapAction"
      @parametros-save="save"
    >
      <template #parametros>
        <v-form ref="formParametros" v-model="formValido">
          <area-form-fields
            :item="editedItem"
            :empresas="empresas"
            :vertices="contagemVertices"
            :desenhando="desenhoAtivo"
            @set="setCampo"
            :unidades-com-centro="unidadesComCentro"
            :gerando-area="gerandoArea"
            @toggle-draw="toggleDesenho"
            @clear-polygon="limparPoligono"
            @suggest-from-units="gerarAreaPelasUnidades"
          />
          <area-unidades-table
            class="mt-4"
            :unidades="unidadesArea"
            :sugestoes="sugestoesPendentes"
            :fora-escopo="foraEscopo"
            :can-edit="canEdit"
            :loading="loadingUnidades"
            @add="adicionarUnidades"
            @remove="removerUnidade"
          />
        </v-form>
      </template>
      <template #create-entity>
        <v-form ref="formCreate" v-model="formValido" class="pa-2">
          <area-form-fields
            dense
            :item="editedItem"
            :empresas="empresas"
            :vertices="contagemVertices"
            :desenhando="desenhoAtivo"
            :mostrar-erro-poligono="tentouSalvar"
            @set="setCampo"
            :unidades-com-centro="unidadesComCentro"
            :gerando-area="gerandoArea"
            @toggle-draw="toggleDesenho"
            @clear-polygon="limparPoligono"
            @suggest-from-units="gerarAreaPelasUnidades"
          />
          <area-unidades-table
            class="mt-2"
            :unidades="unidadesArea"
            :sugestoes="sugestoesPendentes"
            :can-edit="canInsert"
            :loading="loadingUnidades"
            @add="adicionarUnidades"
            @remove="removerUnidade"
          />
          <div class="d-flex justify-end pt-2">
            <v-btn color="primary darken-1" class="white--text mr-2" small @click="close">
              {{ $t('button.cancel') }}
            </v-btn>
            <v-btn color="primary darken-1" class="white--text" small :loading="salvando" @click="save">
              {{ $t('button.save') }}
            </v-btn>
          </div>
        </v-form>
      </template>

      <merus-data-table
        :headers="headers"
        :items="areasFiltradas"
        :loading="loadingTable"
        :loading-text="$t('system.messages.loading')"
        sort-by="cod_area"
        item-key="id_area"
        show-select
        v-model="selecionadas"
        dense
        locale="pt"
        cod-tabela="AREAS"
        @update:headers="headers = $event"
        @update:displayedItems="itensExibidos = $event"
      >
        <template v-slot:toolbar>
          <CadastroToolbar
            :title="$t('area.title')"
            :token="token"
            :items="itensExibidos !== null ? itensExibidos : areasFiltradas"
            :csv-title="$t('area.title')"
            :pdf-title="$t('area.title')"
            :pdf-headers="headers"
            pdf-filename="areasdeplanejamento"
            :csv-headers="headers"
            csv-filename="areasdeplanejamento"
            hide-search
          >
            <template v-slot:extension>
              <v-switch v-model="mostrarInativos" :label="$t('crudVeiculos.showInactive')" class="ml-3 mr-4" hide-details />
              <v-switch v-model="somenteZonasRisco" :label="$t('area.onlyRiskZones')" class="mr-4" hide-details />
            </template>
            <template v-slot:add v-if="canInsert">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark small class="mb-2 mr-2" fab v-on="on" @click="startCreate">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('area.form.createTitle') }}</span>
              </v-tooltip>
            </template>
          </CadastroToolbar>
        </template>
        <template v-slot:item.zona_risco_extenso="{ item }">
          <v-chip v-if="Number(item.zona_risco) === 1" x-small color="red darken-2" text-color="white">
            <v-icon x-small left>{{ iconeZonaRisco }}</v-icon>{{ $t('area.riskZone') }}
          </v-chip>
          <span v-else class="grey--text">—</span>
        </template>
        <template v-slot:item.qtd_unidades="{ item }">
          {{ item.qtd_unidades }}
          <v-tooltip v-if="Number(item.qtd_unidades_sem_centro) > 0" top>
            <template v-slot:activator="{ on }">
              <v-icon x-small color="orange darken-2" v-on="on">mdi-map-marker-off</v-icon>
            </template>
            <span>{{ $t('area.units.noCenterCount', { count: item.qtd_unidades_sem_centro }) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small color="red" :disabled="Number(item.ativa) === 0 || !canDelete" @click.stop="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </merus-data-table>
    </recursos-operacionais-split-layout>
  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import RecursosOperacionaisSplitLayout from "./Linhas/RecursosOperacionaisSplitLayout.vue";
import AreaUnidadesTable from "./Linhas/AreaUnidadesTable.vue";
import AreaFormFields from "./Linhas/AreaFormFields.vue";
import { currentPageItem, mergeSelectionWithPage, dropFromSelection } from "@/utils/tableSelection";
import {
  verticesDaArea,
  situacaoDaUnidade,
  areaEnvolvendoUnidades,
  geometriaParaSalvar,
  SITUACAO,
} from "@/utils/areasGeometria";
import { ICONE_ZONA_RISCO } from "@/utils/areasMapa";

const ITEM_PADRAO = {
  id_area: null,
  cod_area: "",
  nome_area: "",
  shape: null,
  geojson: null,
  cor: null,
  zona_risco: 0,
  alarme_entrada: 0,
  alarme_saida: 0,
  observacoes: null,
  id_empresa: null,
  ativa: 1,
};

/**
 * Áreas de Planejamento (clusters de unidades de negócio), módulo "areas" de Recursos
 * Operacionais. O polígono é desenhado no mapa (AreaMapEditor) e as unidades ficam no
 * formulário até salvar: a API recusa unidade com centro fora do polígono (400).
 */
export default {
  name: "CRUDAreas",
  components: {
    MerusDataTable,
    CadastroToolbar,
    RecursosOperacionaisSplitLayout,
    AreaUnidadesTable,
    AreaFormFields,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    areas: [],
    empresas: [],
    loadingTable: true,
    mostrarInativos: false,
    somenteZonasRisco: false,
    itensExibidos: null,
    selecionadas: [],
    parametrosPage: 0,
    areaSelecionada: null,
    editedItem: Object.assign({}, ITEM_PADRAO),
    criando: false,
    formValido: true,
    tentouSalvar: false,
    salvando: false,
    desenhoAtivo: false,
    gerandoArea: false,
    unidadesArea: [],
    foraEscopo: 0,
    sugestoes: [],
    loadingUnidades: false,
    sugestoesSeq: 0,
    unidadesSeq: 0,
    sugestoesTimer: null,
    confirmDialog: false,
    mensagemDialog: "",
    itemExclusao: null,
    canInsert: false,
    canEdit: false,
    canDelete: false,
    iconeZonaRisco: ICONE_ZONA_RISCO,
  }),
  computed: {
    areasFiltradas() {
      return this.areas.filter((a) => {
        if (!this.mostrarInativos && Number(a.ativa) !== 1) return false;
        if (this.somenteZonasRisco && Number(a.zona_risco) !== 1) return false;
        return true;
      });
    },
    itemParametrosAtual() {
      return currentPageItem(this.selecionadas, this.parametrosPage);
    },
    parametrosLabel() {
      const item = this.itemParametrosAtual;
      return item ? [item.cod_area, item.nome_area].filter(Boolean).join(" — ") : null;
    },
    contagemVertices() {
      const v = verticesDaArea(this.editedItem);
      return v ? v.length : 0;
    },
    unidadesComCentro() {
      return this.unidadesArea.filter((u) => situacaoDaUnidade(null, u) !== SITUACAO.SEM_CENTRO).length;
    },
    idsUnidadesArea() {
      return this.unidadesArea.map((u) => Number(u.id_unidade));
    },
    sugestoesPendentes() {
      const ja = new Set(this.idsUnidadesArea);
      return this.sugestoes.filter((u) => !ja.has(Number(u.id_unidade)));
    },
    areaMapData() {
      const editando = this.criando || (this.editedItem && this.editedItem.id_area != null);
      return {
        area: editando ? this.editedItem : null,
        unidades: editando ? this.unidadesArea : [],
        sugestoes: editando && (this.criando ? this.canInsert : this.canEdit) ? this.sugestoesPendentes : [],
      };
    },
  },
  watch: {
    selecionadas(list, prev) {
      if (list !== prev) this.parametrosPage = 0;
    },
    itemParametrosAtual(item) {
      if (this.criando) return;
      this.areaSelecionada = item || null;
      this.carregarItem(item);
    },
    "$i18n.locale"() {
      this.initialize();
    },
  },
  created() {
    try {
      this.user = JSON.parse(sessionStorage.getItem("user"));
    } catch (e) {
      this.user = null;
    }
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  beforeDestroy() {
    clearTimeout(this.sugestoesTimer);
  },
  methods: {
    populaRecursos() {
      if (this.user && this.user.is_superadmin === 1) {
        this.canEdit = this.canInsert = this.canDelete = true;
        this.initialize();
        return;
      }
      apiController.request(apiController.endpoints.getRecursosusuario, {
        params: { id: this.user && this.user.id_usuario },
        onSuccess: (response) => {
          const recursos = response.data || [];
          const tem = (rota) => recursos.some((r) => r.rota === rota);
          this.canEdit = tem("/api/v1.0/updatearea");
          this.canInsert = tem("/api/v1.0/insertarea");
          this.canDelete = tem("/api/v1.0/deletearea");
          this.initialize();
        },
      });
    },
    initialize() {
      this.loadingTable = true;
      apiController.request(apiController.endpoints.getallAreas, {
        onSuccess: (response) => {
          this.areas = Array.isArray(response.data) ? response.data : [];
          this.loadingTable = false;
          this.selecionadas = mergeSelectionWithPage(this.selecionadas, this.areas, "id_area");
          const item = this.itemParametrosAtual;
          if (item && !this.criando) {
            this.areaSelecionada = item;
            this.carregarItem(item);
          }
        },
        onError: () => {
          this.loadingTable = false;
        },
      }).catch(() => {});
      apiController.request(apiController.endpoints.getallEmpresas, {
        silent: true,
        onSuccess: (response) => {
          this.empresas = response.data || [];
        },
      });
    },
    carregarItem(item) {
      this.tentouSalvar = false;
      this.sugestoes = [];
      if (!item) {
        this.editedItem = Object.assign({}, ITEM_PADRAO);
        this.unidadesArea = [];
        this.foraEscopo = 0;
        return;
      }
      this.editedItem = Object.assign({}, ITEM_PADRAO, item);
      this.carregarUnidades(item.id_area);
    },
    async carregarUnidades(idArea) {
      const seq = ++this.unidadesSeq;
      this.loadingUnidades = true;
      try {
        const res = await apiController.request(apiController.endpoints.getUnidadesareas, {
          data: [idArea],
          silent: true,
        });
        if (seq !== this.unidadesSeq) return;
        const body = res.data || {};
        this.unidadesArea = (body.unidades || []).filter((u) => Number(u.id_area) === Number(idArea));
        this.foraEscopo = Number((body.fora_escopo || {})[idArea]) || 0;
        this.agendarSugestoes();
      } catch (e) {
        if (seq === this.unidadesSeq) this.unidadesArea = [];
      } finally {
        if (seq === this.unidadesSeq) this.loadingUnidades = false;
      }
    },
    /** Reclassifica as unidades no front quando o polígono muda (mesma regra da API). */
    reclassificarUnidades() {
      const temPoligono = !!verticesDaArea(this.editedItem);
      this.unidadesArea = this.unidadesArea.map((u) =>
        Object.assign({}, u, {
          situacao_posicao: temPoligono ? situacaoDaUnidade(this.editedItem, u) : (
            situacaoDaUnidade(null, u) === SITUACAO.SEM_CENTRO ? SITUACAO.SEM_CENTRO : null
          ),
        })
      );
    },
    agendarSugestoes() {
      clearTimeout(this.sugestoesTimer);
      this.sugestoesTimer = setTimeout(() => this.carregarSugestoes(), 250);
    },
    async carregarSugestoes() {
      const seq = ++this.sugestoesSeq;
      const podeEditar = this.criando ? this.canInsert : this.canEdit;
      if (!podeEditar || !verticesDaArea(this.editedItem)) {
        this.sugestoes = [];
        return;
      }
      try {
        const res = await apiController.request(apiController.endpoints.getUnidadessugeridasarea, {
          data: { shape: this.editedItem.shape, geojson: this.editedItem.geojson },
          silent: true,
        });
        if (seq !== this.sugestoesSeq) return;
        this.sugestoes = (res.data && res.data.unidades) || [];
      } catch (e) {
        if (seq === this.sugestoesSeq) this.sugestoes = [];
      }
    },
    async adicionarUnidades(ids) {
      const novos = (ids || []).map(Number).filter((id) => !this.idsUnidadesArea.includes(id));
      if (!novos.length) return;
      // Sugestões já trazem o centro; as demais vêm da API (com a situação).
      const porId = new Map(this.sugestoes.map((u) => [Number(u.id_unidade), u]));
      const faltam = novos.filter((id) => !porId.has(id));
      if (faltam.length) {
        try {
          const res = await apiController.request(apiController.endpoints.getUnidadessugeridasarea, {
            data: { shape: this.editedItem.shape, geojson: this.editedItem.geojson, id_unidades: faltam },
            silent: true,
          });
          ((res.data && res.data.informadas) || []).forEach((u) => porId.set(Number(u.id_unidade), u));
        } catch (e) {
          EventBus.$emit("show-error", { error: e });
          return;
        }
      }
      const adicionadas = novos.map((id) => porId.get(id)).filter(Boolean);
      this.unidadesArea = this.unidadesArea.concat(adicionadas);
      this.reclassificarUnidades();
    },
    removerUnidade(idUnidade) {
      this.unidadesArea = this.unidadesArea.filter((u) => Number(u.id_unidade) !== Number(idUnidade));
    },
    onMapAction({ action, active, geometry, unidade } = {}) {
      if (action === "create-area") return this.startCreate({ fromMap: true });
      if (action === "close-create") return this.close({ fromMap: true });
      if (action === "draw-polygon-mode") {
        this.desenhoAtivo = !!active;
        return undefined;
      }
      if (action === "area-polygon-drawn" || action === "area-polygon-changed") {
        return this.aplicarGeometria(geometry);
      }
      if (action === "suggestion-click" && unidade) return this.adicionarUnidades([unidade.id_unidade]);
      return undefined;
    },
    aplicarGeometria(geometry) {
      if (!geometry) return;
      this.$set(this.editedItem, "shape", geometry.shape);
      this.$set(this.editedItem, "geojson", geometry.geojson);
      this.reclassificarUnidades();
      this.agendarSugestoes();
    },
    /**
     * Sentido inverso ao desenho: a área sai das unidades já associadas (fecho convexo das
     * cercas-centro com margem). O polígono fica editável como um desenhado à mão.
     */
    async gerarAreaPelasUnidades(margem) {
      const m = Number(margem);
      if (!Number.isFinite(m) || m < 10 || m > 50000) {
        this.avisar(this.$t("area.map.fromUnitsMarginInvalid"), "error");
        return;
      }
      if (this.gerandoArea || !this.idsUnidadesArea.length) return;
      if (verticesDaArea(this.editedItem) && !window.confirm(this.$t("area.map.fromUnitsReplaceConfirm"))) return;
      this.gerandoArea = true;
      let unidades;
      try {
        const res = await apiController.request(apiController.endpoints.getUnidadessugeridasarea, {
          data: { id_unidades: this.idsUnidadesArea, incluir_cerca: 1 },
          silent: true,
        });
        unidades = (res.data && res.data.informadas) || [];
      } catch (e) {
        EventBus.$emit("show-error", { error: e });
        return;
      } finally {
        this.gerandoArea = false;
      }
      const { vertices, semCentro } = areaEnvolvendoUnidades(unidades, m);
      if (!vertices) {
        this.avisar(this.$t("area.map.fromUnitsNeedUnits"), "warning");
        return;
      }
      const split = this.$refs.detalheSplit;
      if (this.desenhoAtivo && split) split.setDrawPolygonMode(false);
      this.aplicarGeometria(Object.assign({ vertices }, geometriaParaSalvar(vertices)));
      if (semCentro.length) {
        this.avisar(
          this.$t("area.map.fromUnitsSkippedNoCenter", { units: semCentro.map((u) => u.cod_unidade || u.id_unidade).join(", ") }),
          "warning"
        );
      }
    },
    toggleDesenho() {
      const split = this.$refs.detalheSplit;
      if (split) split.setDrawPolygonMode(!this.desenhoAtivo);
    },
    limparPoligono() {
      this.$set(this.editedItem, "shape", null);
      this.$set(this.editedItem, "geojson", null);
      this.sugestoes = [];
      this.reclassificarUnidades();
    },
    startCreate({ fromMap = false } = {}) {
      this.criando = true;
      this.tentouSalvar = false;
      this.editedItem = Object.assign({}, ITEM_PADRAO);
      if (this.empresas.length === 1) this.editedItem.id_empresa = this.empresas[0].id_empresa;
      this.unidadesArea = [];
      this.foraEscopo = 0;
      this.sugestoes = [];
      this.$nextTick(() => {
        const form = this.$refs.formCreate;
        if (form) form.resetValidation();
        const split = this.$refs.detalheSplit;
        if (split && !fromMap) split.openCreateDrawer({ silent: true });
      });
    },
    close({ fromMap = false } = {}) {
      const split = this.$refs.detalheSplit;
      if (split && !fromMap) split.closeCreateDrawer({ silent: true });
      this.criando = false;
      this.desenhoAtivo = false;
      this.carregarItem(this.itemParametrosAtual);
    },
    payload() {
      const item = this.editedItem;
      return {
        id_area: item.id_area,
        cod_area: item.cod_area ? String(item.cod_area).trim() : item.cod_area,
        nome_area: item.nome_area ? String(item.nome_area).trim() : item.nome_area,
        shape: item.shape,
        geojson: item.geojson,
        cor: item.cor || null,
        zona_risco: Number(item.zona_risco) === 1 ? 1 : 0,
        alarme_entrada: Number(item.alarme_entrada) === 1 ? 1 : 0,
        alarme_saida: Number(item.alarme_saida) === 1 ? 1 : 0,
        observacoes: item.observacoes || null,
        id_empresa: item.id_empresa || null,
        ativa: Number(item.ativa) === 0 ? 0 : 1,
        id_unidades: this.idsUnidadesArea,
      };
    },
    validarAntesDeSalvar() {
      this.tentouSalvar = true;
      const form = this.criando ? this.$refs.formCreate : this.$refs.formParametros;
      if (form && !form.validate()) return false;
      if (!verticesDaArea(this.editedItem)) {
        this.avisar(this.$t("area.validation.polygonRequired"), "error");
        return false;
      }
      const fora = this.unidadesArea.filter((u) => u.situacao_posicao === SITUACAO.FORA);
      if (fora.length) {
        this.avisar(this.$t("area.units.outsideError", { units: fora.map((u) => u.cod_unidade || u.id_unidade).join(", ") }), "error");
        return false;
      }
      return true;
    },
    save() {
      const podeSalvar = this.criando ? this.canInsert : this.canEdit;
      if (!podeSalvar || this.salvando || !this.validarAntesDeSalvar()) return;
      const criando = this.criando;
      const endpoint = criando ? apiController.endpoints.insertArea : apiController.endpoints.updateArea;
      this.salvando = true;
      apiController.request(endpoint, {
        data: this.payload(),
        silent: true,
        onSuccess: (response) => {
          this.salvando = false;
          const body = response.data || {};
          if (body.erro) {
            this.avisar(body.mensagem, "error");
            return;
          }
          this.avisar(this.$t(criando ? "area.updateTable.success.insert" : "area.updateTable.success.update"), "success");
          const semCentro = body.avisos && body.avisos.unidadesSemCentro;
          if (semCentro && semCentro.length) {
            this.avisar(this.$t("area.units.noCenterWarning", { units: semCentro.map((u) => u.cod_unidade || u.id_unidade).join(", ") }), "warning");
          }
          if (criando) this.close();
          this.initialize();
        },
        onError: (error) => {
          this.salvando = false;
          const body = error && error.response && error.response.data;
          if (body && Array.isArray(body.unidadesForaDaArea)) {
            const fora = new Set(body.unidadesForaDaArea.map((u) => Number(u.id_unidade)));
            this.unidadesArea = this.unidadesArea.map((u) =>
              fora.has(Number(u.id_unidade)) ? Object.assign({}, u, { situacao_posicao: SITUACAO.FORA }) : u
            );
          }
          this.avisar((body && body.mensagem) || this.$t("area.updateTable.error.update"), "error");
        },
      }).catch(() => {});
    },
    setCampo(campo, valor) {
      this.$set(this.editedItem, campo, valor);
    },
    avisar(mensagem, tipo) {
      EventBus.$emit("show-alert", { mensagem, tipo, duracao: tipo === "error" ? 8000 : 5000 });
    },
    deleteItem(item) {
      this.itemExclusao = item;
      this.mensagemDialog = this.$t("area.confirmDeactivation", { area: item.nome_area });
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      const item = this.itemExclusao;
      this.confirmDialog = false;
      if (!item) return;
      apiController.request(apiController.endpoints.deleteArea, {
        data: { id_area: item.id_area },
        onSuccess: () => {
          this.avisar(this.$t("area.updateTable.success.delete"), "success");
          this.selecionadas = dropFromSelection(this.selecionadas, [item.id_area], "id_area");
          this.initialize();
        },
      }).catch(() => {});
    },
  },
};
</script>
